import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TaskAltTwoToneIcon from '@mui/icons-material/TaskAltTwoTone';
import Typography from '@mui/material/Typography';
import { CurrentPlan } from './types';

export interface Props {
  selectedPlanName: string;
  currentPlan: CurrentPlan;
  totalAmountDue: string;
  minConversionLicenses: number;
}

function PaymentSummary({ selectedPlanName, currentPlan, totalAmountDue, minConversionLicenses }: Readonly<Props>) {
  return (
    <Box sx={{ padding: 0 }}>
      <Typography mb={1}>
        Thanks for choosing the
        {' '}
        <Typography fontWeight="bold" component="span">
          {selectedPlanName}
          {' '}
          Plan
        </Typography>
      </Typography>
      <Box>
        <Typography fontWeight="bold">Details:</Typography>
        <List dense>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: 0, marginRight: 1 }}>
              <TaskAltTwoToneIcon sx={{ color: '#87D30F' }} />
            </ListItemIcon>
            <ListItemText primary={`${selectedPlanName} Plan`} />
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: 0, marginRight: 1 }}>
              <TaskAltTwoToneIcon sx={{ color: '#87D30F' }} />
            </ListItemIcon>
            <ListItemText primary={`${Math.max(currentPlan.usage?.licenses ?? 0, minConversionLicenses)} Users`} />
          </ListItem>
        </List>
      </Box>
      <Typography fontWeight="bold">{`Total Due Today: ${totalAmountDue}`}</Typography>
    </Box>
  );
}

export default PaymentSummary;
